import { Routes, Route } from 'react-router-dom'

// Components
import Gallery from './components/gallery/Gallery'

// Styles
import styles from './App.module.scss'

function App() {
  return (
    <div className={styles.app}>

      <Routes>
        <Route path="/" element={<Gallery />} />
      </Routes>

    </div>
  )
}

export default App
